<template>
  <div class="fullwidth about narex">
    <editable-item :page="$route.name" item="text" :loaded="editableLoaded" />
    <div class="narrow">
      <div class="signin" v-if="validLink">
        <div class="padform">
          <label for="username">{{ $nippets.myarea.email }}</label>
          <input type="email" v-model="email" name="email" />
        </div>
        <div class="button-panel">
          <small-button v-on:click="handleEnterCode" large>{{ $nippets.myarea.enter }}</small-button>
        </div>
      </div>
      <div v-if="!validLink">
        <p>
          You have followed an invalid link to this page. Please click the link in your email or 
          copy and paste the URL into your browser.
        </p>
      </div>
    </div>
  </div>

</template>

<script>
import '@/auth-handler.js'
import Auth from '@aws-amplify/auth'
import EditablePage from '@/mixins/EditablePage.js'
import '@/css/my-area.css'

export default {
  mixins: [EditablePage],
  data: function () {
    return {
      email: '',
      code: '',
      validLink: true
    }
  },
  created () {
    if(localStorage.illuxSignupEmail) {
      this.email = localStorage.illuxSignupEmail
    }
    this.code = this.$route.query.code
    if(!this.code) {
      //this.validLink = false
    }
    if(this.code && this.$k.validEmail(this.email)) {
      this.handleEnterCode()
    }
  },
  methods: {
    handleEnterCode: async function () {
      try {
        Auth.confirmSignUp(this.email, this.code)
        this.$k.messageBox(this.$nippets.signup, 'You have succesfully confirmed your sign up. You may now log in.')
        this.$ixr.push('/')
        await this.$k.waitfor(200)
        this.$store.commit('showLogin')
      }
      catch(err){
        this.$k.messageBox(this.$nippets.signup, err.message)
        return
      }
      
    }
  }
}
</script>

<style scoped>
.narrow{
  max-width:500px;
}
</style>